import React, {useState} from "react";
import {
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle, Input, InputGroup, InputGroupAddon,
  Nav,
  Navbar,
  NavbarToggler, NavItem,
  UncontrolledDropdown
} from "reactstrap";
import AppLogo from "../../Assets/Images/logoApp.png";
import {faSearch, faUser} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {AuthActions} from "../../Store/Auth/Slice";
import {useDispatch, useSelector} from "react-redux";
import CompanyNameComponent from "./CompanyNameComponent";
import {SideMenuActions} from "../../Store/SideMenu/Slice";
import {RootState} from "../../Store/Reducers";
import {ModalActions} from "../../Store/Modal/Slice";
import {RECOVER_PASSWORD_MODAL} from "../../Store/Modal/Types";
import { useHistory } from "react-router-dom";
import {onSearchShipment} from "../../Utils/Utils";
import ButtonAction from "../Shared/ButtonAction";

const NavBarComponent = () => {

  const dispatch = useDispatch();

  let history = useHistory();

  const [consecutive, setConsecutive] = useState<string>('');

  const {SideMenuReducer: {state}, authReducer: {user, logged}} = useSelector((state: RootState) => state);

  const logout = () => {
    dispatch(AuthActions.logout());
    redirectTo('login');
  };

  const openSideMenu = () => {
    dispatch(SideMenuActions.changeStatus({...state, "left": true }));
  };

  const changeUserPassword = () => {
    dispatch(ModalActions.openModal({modal:RECOVER_PASSWORD_MODAL}));
  };

  const redirectTo = (path:string) => {
    history.push(`/${path}`);
  };

  return (
    <div className="sticky-nav">
      <Navbar className="nav-container" light expand="md">
        <NavbarToggler onClick={openSideMenu} className="outline-none"/>
        <button onClick={() => redirectTo('dashboard')} className="btn btn-link nav-item-logo navbar-brand clickable">
          <img src={AppLogo} width="150px" alt="AURABA" />
        </button>

        <Collapse isOpen={false} navbar>
          <Nav className="mx-auto" navbar>
            <NavItem className="ml-3">
              <InputGroup>
                <Input type="number" placeholder="Numero de Guia"
                       name="consecutive" value={consecutive}
                       onChange={(e) => setConsecutive(e.target.value)}
                />
                <InputGroupAddon addonType="append">
                  <ButtonAction action={{
                    icon: faSearch,
                    color: 'primary',
                    outline: true,
                    onClick: () => onSearchShipment(history, consecutive)
                  }}/>
                </InputGroupAddon>
              </InputGroup>
            </NavItem>
          </Nav>

          {
            logged &&
            <Nav className="ml-auto" navbar>
              <CompanyNameComponent/>
              <UncontrolledDropdown className="mx-2" nav inNavbar>
                <DropdownToggle nav caret>
                  <FontAwesomeIcon icon={faUser}/>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem className="text-capitalize text-center">
                    {user.name}
                  </DropdownItem>
                  <DropdownItem onClick={changeUserPassword} className="text-capitalize text-center">
                    Cambiar contraseña
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={()=>redirectTo('dashboard')} className="text-capitalize text-center">
                    Inicio
                  </DropdownItem>
                  <DropdownItem onClick={()=>redirectTo('billing')} className="text-capitalize text-center">
                    Facturas
                  </DropdownItem>
                  <DropdownItem onClick={()=>redirectTo('reports')} className="text-capitalize text-center">
                    Informe gerencial
                  </DropdownItem>
                  <DropdownItem onClick={()=>redirectTo('history')} className="text-capitalize text-center">
                    Historial
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={logout} className="text-capitalize text-center">
                    Salir
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          }
        </Collapse>
      </Navbar>
    </div>
  );
};

export default NavBarComponent;
